import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';
import { FundGivingEngine } from '@Types';
import { useCallback } from 'react';

export const useGetFundGivingEngine = () => {
  const [fetch, response] = useRequest<FundGivingEngine>();

  const getFundGivingEngine = useCallback(
    (fundId: number, accessCode?: string | null) => {
      fetch(API.paths.fund_giving_engine(fundId, accessCode), 'get');
    },
    [fetch],
  );

  return [getFundGivingEngine, response] as const;
};
